import { Component, input } from '@angular/core';

import { AlertType } from '../../models/alert-type';
import { AlertComponent } from './alert.component';

// <app-alert-info> - an app-alert whose type is info, so a template need not pass the type as a
// string (Chris, PR 2581). It still takes a type, as app-alert does.
@Component({
  selector: 'app-alert-info',
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertInfoComponent extends AlertComponent {
  public override readonly type = input<AlertType>('info');
}
